import { HookOutOfContextError } from "@jugl-web/utils";
import { useContext } from "react";
import { CustomThemeContext } from "./CustomThemeContext";

export const useTheme = () => {
  const context = useContext(CustomThemeContext);

  if (!context) {
    throw new HookOutOfContextError("useTheme", "ThemeContext");
  }

  return context;
};
